import { ReactPortal, useEffect } from 'react';
import { createPortal } from 'react-dom';

import { REACT_ROOT_ID } from '@/config/common.config';


interface IPortalProps {
  children: any;
}

export default function Portal({ children }: IPortalProps): ReactPortal {
  const mount = document.getElementById(REACT_ROOT_ID);
  const el = document.createElement('div');

  useEffect(() => {
    mount?.appendChild(el);

    return () => {
      mount?.removeChild(el);
    };
  }, [el, mount]);

  return createPortal(children, el);
}
